module.exports = __webpack_public_path__ + "img/platinum_plus_product_img.ee0104e8.jpg";